import React from 'react';
import { Card, Badge, Button, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEllipsisV, 
  faEdit, 
  faTrash, 
  faBell, 
  faClock,
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

const AlertRuleCard = ({ rule, onEdit, onDelete }) => {
  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(rule);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(rule);
  };

  return (
    <Card className="alert-rule-card h-100">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center flex-grow-1">
          <FontAwesomeIcon icon={faBell} className="me-2 text-primary" />
          <h6 className="mb-0 text-truncate" title={rule.name}>
            {rule.name}
          </h6>
        </div>
        <Dropdown align="end" onClick={(e) => e.stopPropagation()}>
          <Dropdown.Toggle 
            variant="link" 
            className="text-muted p-0 no-caret"
            id={`dropdown-${rule.id}`}
          >
            <FontAwesomeIcon icon={faEllipsisV} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={handleEdit}>
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              Edit
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleDelete} className="text-danger">
              <FontAwesomeIcon icon={faTrash} className="me-2" />
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>
        <div className="alert-rule-details">
          {/* Status Badge */}
          <div className="mb-3">
            <Badge 
              bg={rule.isEnabled ? 'success' : 'secondary'}
              className="d-flex align-items-center w-fit"
            >
              <FontAwesomeIcon 
                icon={rule.isEnabled ? faCheckCircle : faTimesCircle} 
                className="me-1" 
              />
              {rule.isEnabled ? 'Enabled' : 'Disabled'}
            </Badge>
          </div>

          {/* Alert Type */}
          <div className="mb-2">
            <small className="text-muted d-block">Alert Type</small>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faBell} className="me-2 text-warning" size="sm" />
              <span className="fw-medium">{rule.alertType}</span>
            </div>
          </div>

          {/* Criteria Summary */}
          {rule.criteria && (
            <div className="mb-2">
              <small className="text-muted d-block">Criteria</small>
              <div className="criteria-summary">
                {rule.criteria.module && (
                  <Badge bg="light" text="dark" className="me-1 mb-1">
                    {rule.criteria.module}
                  </Badge>
                )}
                {rule.criteria.meterId?.length > 0 && (
                  <Badge bg="info" className="me-1 mb-1">
                    {rule.criteria.meterId.length} Meter{rule.criteria.meterId.length !== 1 ? 's' : ''}
                  </Badge>
                )}
              </div>
            </div>
          )}

          {/* Escalation Levels */}
          {rule.escalationPolicy && rule.escalationPolicy.length > 0 && (
            <div className="mb-0">
              <small className="text-muted d-block">Escalation Levels</small>
              <span className="fw-medium">{rule.escalationPolicy.length} Level{rule.escalationPolicy.length !== 1 ? 's' : ''}</span>
            </div>
          )}
        </div>
      </Card.Body>

      <Card.Footer className="text-muted">
        <small>
          Updated: {new Date(rule.updatedAt).toLocaleDateString()}
        </small>
      </Card.Footer>
    </Card>
  );
};

export default AlertRuleCard;